<div #printRoot
  class="w-full p-4 m-auto bg-white rounded-lg shadow-lg font-body md:p-12 print:p-0 print:shadow-none">
  @if (config?.title) {
    <h2 class="mb-4 text-xl font-weight-bold md:text-3xl">
      {{ config?.title }}
    </h2>
  }

  <div class="flex flex-col-reverse items-start gap-2 mb-4 md:flex-row md:items-center md:justify-between">
    @if (config?.sectionTitle) {
      <h3 class="text-lg font-bold">
        {{ config?.sectionTitle }}
      </h3>
    }
    @if (config?.printEnabled !== false) {
      <button type="button"
        class="px-3 py-2 ml-auto text-xs font-bold border rounded-sm shadow-sm md:text-sm text-th-primary print:hidden"
        (click)="print()">
        {{ printLabel }}
      </button>
    }
  </div>

  @for (paragraph of config?.paragraphs; track $index) {
    <p class="mb-4">{{ paragraph }}</p>
  }

  @if (config?.importantInformation?.length) {
    <hr class="my-6 border-gray">
    <!-- Static label: not yet config-driven (PA-6202 open item 2) -->
    <h3 class="mb-2 text-sm font-bold text-black/70">Important Information</h3>
    @for (paragraph of config?.importantInformation; track $index) {
      <p class="mb-2 text-xs text-black/70">{{ paragraph }}</p>
    }
  }
</div>
